// SDK工具函数
import { ElMessage } from "element-plus";
import moment from "moment";
import { sendImMessage } from "../api/im.js";

/**
 * 判斷是否為空
 * @returns {boolean}
 */
export const empty = function (d) {
	if (
		typeof d === "undefined" ||
		d === null ||
		d === "null" ||
		d === "NULL" ||
		d === "" ||
		d === "undefined" ||
		JSON.stringify(d) === "[]" ||
		JSON.stringify(d) === "{}"
	) {
		return true;
	} else {
		return false;
	}
};

// 手机号校验
export function formatPhone(value) {
  return value.replace(/\D/g, '').substring(0, 11)
}

export const phoneReg = /^1[3-9]\d{9}$/; // 手机号正则表达式
/**
 * 验证手机号
 * @param phone
 * @param type toast 提示框， text 不提示，返回文案
 * @returns {boolean}
 */
export const validatePhone = function (phone, type = "toast") {
    if (empty(phone)) {
        if (type === "toast") {
            ElMessage({
                message: "请输入手机号",
                type: "warning",
            });
            return false;
        } else {
            return "请输入手机号";
        }
    }
    if (!phoneReg.test(phone)) {
        if (type === "toast") {
			ElMessage({
                message: "手机号格式不正确",
                type: "warning",
            });
            return false;
        } else {
            return "手机号格式不正确";
        }
    }
    return true;
};

/**
 * 格式化日期
 * @param {number} t 时间戳
 * @return {string} MM-dd HH:mm
 */
export function formatDate(t) {
	t = t || Date.now();
	let time = new Date(t);
	let str =
		time.getMonth() < 9 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1;
	str += "-";
	str += time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
	str += " ";
	str += time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
	str += ":";
	str += time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
	return str;
}

/**
 * 显示时间：
 * - 今天：HH:mm
 * - 昨天：昨天 HH:mm
 * - 本周（除今天/昨天）：周几
 * - 今年但非本周：MM-dd（不显示年份）
 * - 其他年份：yyyy-MM-dd
 * @param {number|string} t 时间戳或日期字符串
 * @param {boolean} isShowHm 是否显示时分，默认显示
 * @return {string}
 */
export function formatTimeHHmm(t, isShowHm = true) {
	if (t === null || t === undefined) return "";
	const m = moment(t);
	if (!m.isValid()) return t;

	const now = moment();

	if (m.isSame(now, "day")) {
		return m.format("HH:mm");
	}

	if (m.isSame(now.clone().subtract(1, "day"), "day")) {
		return `昨天 ${m.format("HH:mm")}`;
	}

	// 使用 ISO 周：周一为一周起点
	const startOfWeek = now.clone().startOf("isoWeek");
	const endOfWeek = now.clone().endOf("isoWeek");
	const isThisWeek =
		m.isSameOrAfter(startOfWeek, "day") &&
		m.isSameOrBefore(endOfWeek, "day");

	if (isThisWeek) {
		// isoWeekday: 周一=1 ... 周日=7
		const weekNames = ["一", "二", "三", "四", "五", "六", "日"];
		return `星期${weekNames[m.isoWeekday() - 1]}${isShowHm ? ` ${m.format("HH:mm")}` : ""}`;
	}

	return m.isSame(now, "year")
		? isShowHm ? m.format("MM/DD HH:mm") : m.format("MM/DD")
		: m.format("YYYY/MM/DD");
}

/**
 * 距当前时间点的时长
 * @param {number} time 13位时间戳
 * @return {string} x秒 / x分钟 / x小时
 */
export function formateTime(time) {
	const second = 1000;
	const minute = second * 60;
	const hour = minute * 60;
	const day = hour * 24;
	const now = new Date().getTime();
	const diffValue = now - time;

	// 计算差异时间的量级
	const secondC = diffValue / second;
	const minC = diffValue / minute;
	const hourC = diffValue / hour;
	const dayC = diffValue / day;

	if (dayC >= 1) {
		return parseInt(dayC) + "天";
	} else if (hourC >= 1) {
		return parseInt(hourC) + "小时";
	} else if (minC >= 1) {
		return parseInt(minC) + "分钟";
	} else if (secondC >= 1) {
		return parseInt(secondC) + "秒";
	} else {
		return "0秒";
	}
}

/**
 * 统一通信上使用的用户信息字段
 * @returns
 */
export function getUserInfo() {
	return JSON.parse(localStorage.getItem("goUserInfo") || "{}");
}

const USER_TYPE = {
	JZ: "家长",
	XS: "学生",
	TGY: "推广员",
	GHS: "规划师",
	BXS: "伴学师",
};
export function getUserType(userId) {
	return USER_TYPE[userId.split("_")[0]] || "";
}

/**
 * 按字段key值分组
 * @param {Array} userList 用户列表
 * @param {string} key 分组字段
 * @returns {Array} 分组后的列表
 */
export function groupUserList(userList, key = "userType") {
	if (userList.length == 0) {
		return [];
	}

	const groupedData = {};
	userList.forEach((item) => {
		const keyword = item[key];
		if (!groupedData[keyword]) {
			groupedData[keyword] = [];
		}
		groupedData[keyword].push(item);
	});

	return Object.keys(groupedData).map((item) => ({
		[key]: item,
		list: groupedData[item],
	}));
}

// import { API_BASE_URL } from "../api/index.js";
/**
 * 上传图片
 * @param sourceType: ['album', 'camera'] 选择图片的来源，默认是相册
 * @param mediaType: ['image', 'video'] 选择图片的类型，默认是图片
 * @param count: 9（注意：ios不可大于9） 选择图片的数量，默认是1
 * @param crop 裁剪图片，默认不裁剪
 */
export const xftpUpload = function () {
	// return new Promise((resolve, reject) => {
	// 	fetch(API_BASE_URL + "/xftp/upload", {
	// 		method: "POST",
	// 		body: formData,
	// 	})
	// 		.then((response) => response.json())
	// 		.then((data) => {
	// 			if (data.code === 200) {
	// 				resolve(data.data.url);
	// 			} else {
	// 				reject(data.msg);
	// 			}
	// 		})
	// 		.catch((error) => {
	// 			reject(error);
	// 		});
	// });
};

import { getQiniuToken } from "../api/im.js";
export const getQiniuInfo = function (fileName) {
	return new Promise((resolve, reject) => {
		getQiniuToken({ fileName })
			.then((res) => {
				resolve(res);
			})
			.catch((e) => {
				console.error(247, e);
				reject("");
			});
	});
};

// 下面的没用到

/**
 * 深拷贝对象
 * @param {*} obj 要拷贝的对象
 * @returns {*} 拷贝后的对象
 */
export function deepClone(obj) {
	if (obj === null || typeof obj !== "object") {
		return obj;
	}

	if (obj instanceof Date) {
		return new Date(obj.getTime());
	}

	if (obj instanceof Array) {
		return obj.map((item) => deepClone(item));
	}

	if (typeof obj === "object") {
		const clonedObj = {};
		for (const key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				clonedObj[key] = deepClone(obj[key]);
			}
		}
		return clonedObj;
	}
}

/**
 * 生成唯一ID
 * @returns {string} 唯一ID
 */
export function generateUniqueId() {
	return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

// 防抖节流函数
export function debounce(func, wait, immediate) {
	let timeout; // 定义一个计时器变量，用于延迟执行函数
	return function (...args) {
		// 返回一个包装后的函数
		const context = this; // 保存函数执行上下文对象
		const later = function () {
			// 定义延迟执行的函数
			timeout = null; // 清空计时器变量
			if (!immediate) func.apply(context, args); // 若非立即执行，则调用待防抖函数
		};
		const callNow = immediate && !timeout; // 是否立即调用函数的条件
		clearTimeout(timeout); // 清空计时器
		timeout = setTimeout(later, wait); // 创建新的计时器，延迟执行函数
		if (callNow) func.apply(context, args); // 如果满足立即调用条件，则立即执行函数
	};
}

/**
 * 判断是否为移动端
 * @returns {boolean}
 */
export function isMobilePage() {
	// H5：尽量同时兼容 UA + 视口宽度两种判断
	if (typeof window === "undefined") return false;
	const ua = navigator.userAgent || "";
	const uaMobile =
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
	const widthMobile =
		typeof window.matchMedia === "function"
			? window.matchMedia("(max-width: 768px)").matches
			: window.innerWidth <= 768;
	return uaMobile || widthMobile;
}

/**
 * 格式化通话时长
 * @param {number} seconds 通话时长，单位：秒
 * @returns {string} mm:ss
 */
export function formattedDuration(sec) {
	let seconds = Number(sec) || 0;
    if (typeof seconds !== 'number' || isNaN(seconds)) {
        return '00:00';
    }
    const minutes = Math.floor(seconds / 60);
    const formattedSeconds = String(seconds % 60).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds}`; // mm:ss
}

let lastRtcImKey = "";
let lastRtcImTs = 0;

/**
 * 发送音视频通话状态消息（用于会话列表/聊天记录展示）
 * - msgType: videoCall / audioCall
 * - fileName: 原因（CANCELLED/HUNG_UP/REJECTED/NO_ANSWER/GOEASY_DISCONNECTED/...）
 * - content: 时长（秒，字符串），供后端落库到 msgContent
 */
export async function sendRtcCallImMessage({
	reason,
	durationSec,
} = {}) {
	const ctx = getRtcCallContext();
	if (!ctx) return;
	const userInfo = getUserInfo();
	// 仅通话发起人（caller）上报通话状态，避免被叫方重复写会话
	const call =
		typeof window !== "undefined" ? window.GRTC?.currentCall?.() : null;
	const initiatorId = call?.caller?.id ?? ctx.initiatorUserId;
	if (!userInfo?.userId || !initiatorId || initiatorId !== userInfo.userId) {
		return;
	}
	const mediaType = Number(ctx.mediaType);
	const msgType = ctx.msgType || (mediaType === 1 ? "videoCall" : "audioCall");
	const duration = Math.max(0, Number(durationSec) || 0);
	const fileName = duration ? reason || "HUNG_UP" : "CANCELLED";
	// const fileName = !durationSec ? ` ${msgType} ${reason}` : "HUNG_UP"; // CANCELLED

	// 兜底：缺少关键上下文时不发送
	if (!ctx.sceneId) return;
	if (!ctx.groupId && !ctx.toId) return;

	// 去重：同一条 reason+duration 在短时间内只发一次
	const key = [
		String(ctx.sceneId || ""),
		String(ctx.groupId || ""),
		String(ctx.toId || ""),
		String(msgType),
		String(fileName),
		String(duration),
	].join("|");
	const now = Date.now();
	if (key && key === lastRtcImKey && now - lastRtcImTs < 1500) return;
	lastRtcImKey = key;
	lastRtcImTs = now;

	const payload = {
		userId: userInfo?.userId,
		msgType,
		fileName,
		content: String(duration),
		sceneId: ctx.sceneId,
		onlineOnlyFlag: 1,
	};
	if (ctx.groupId) {
		payload.groupId = ctx.groupId;
		payload.avatar = userInfo?.avatar;
	} else {
		payload.toId = ctx.toId;
	}
	try {
		await sendImMessage(payload);
	} catch (e) {
		console.error("sendRtcCallImMessage failed", e);
	}
}

/**
 * 获取本地缓存的通话上下文（sceneId/toId/groupId）
 */
export function getRtcCallContext() {
	try {
		return JSON.parse(localStorage.getItem("grtc_call_context") || "{}");
	} catch {
		return {};
	}
}

/**
 * 写入本地缓存的通话上下文（sceneId/toId/groupId/initiatorUserId 等）
 */
export function setRtcCallContext(ctx = {}) {
	try {
		localStorage.setItem("grtc_call_context", JSON.stringify(ctx || {}));
	} catch (e) {
		console.error("setRtcCallContext failed", e);
	}
}